define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/heading/Renderer",
	"csi/middleware/rollup/rollupService",
	"csi/types",
	"csi/xml"
], function(declare, _, csiHeading, Renderer, {evaluate}, types, xml) {

	return declare(Renderer, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert value to displayed value based on format
			if (fmt && _.isNumber(value)) {
				if (types.isTimeFormat(fmt)) {
					value = types.formatTime(value, fmt);
				} else {
					value = types.getNumberRead(value, fmt);
				}
			}

			return String(value);
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if heading has id, then get CSS from attribute renderer; otherwise rely on Heading/@Class
			if (h.m_id) {
				var ren = csiHeading.getRenderer(h.getAttrType(), this._getFormat(ctx, h));
				if (ren) {
					return ren.css;
				}
			}

			return this.inherited(arguments);
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return evaluated value for expression
			return ctx.bReporting ? "" : evaluate(h.m_value, ctx.getNode(), ctx.cache, false, ctx);
		}
	});
});